import { Container, Grid, Button } from "@material-ui/core"
import HomePage from "../../Home"
import Cabecera from "./Cabecera"
import BAccion from "./BAccion"
import Cancelaciones from "./../Cancelaciones"
import CambioPasajeros from "../CambioPasajero"
import CambioFecha from "../CambioFecha"
import CambioPaquete from "../CambioPaquete"
import { useSelector, useDispatch } from "react-redux"
import { catCambios } from "../../../constant/catCambios"
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn"
import { useHistory, useLocation } from "react-router-dom"
import { useEstatusPaqueteValido } from "../../../hooks/useEstusPaqueteValido"
import { useEffect } from "react"
import { selectIsCancelacionAction } from "./../../../ducks/cambiosDuck"
const VCambios = () => {
    const { referencia, accion, estatusProceso, isCancelacion } = useSelector(store => store.cambios)
    const [valido] = useEstatusPaqueteValido({ estatus: estatusProceso?.IdEstatusProceso })
    const history = useHistory()
    const location = useLocation()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(selectIsCancelacionAction({isCancelacion: location?.pathname.includes('/Cancelaciones')}))
    }, [dispatch, location.pathname])
    const onReturn = () => {
        history.goBack()
    }
    return (
        <HomePage>
            <Container>
                <Grid container>
                    <Grid item xs={12}>
                        <h1>
                        {
                            isCancelacion ? "Cancelación" : "Cambios"
                        } 
                        </h1>
                    
                        {
                            (location.state.reservas) ?
                                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                    <Button variant="contained" onClick={onReturn}>
                                        <KeyboardReturnIcon />
                                        Regresar
                                    </Button>
                                </div>
                                :
                                null
                        }
                        <Cabecera />
                    </Grid>
                    {
                        (!valido) &&
                        <Grid item xs={12}>
                            <div style={{ textAlign: "center" }}>
                                <h2>Este paquete esta en estatus de {estatusProceso?.Descripcion}</h2>
                            </div>
                        </Grid>
                    }
                    {
                        (referencia && valido) &&
                        <Grid item xs={12}>
                            <BAccion />
                        </Grid>
                    }
                    {
                        (referencia && valido) &&
                        <Grid item xs={12}>
                            {
                                (accion === catCambios.CAMBIO_FECHA) &&
                                <CambioFecha />
                            }
                            {
                                (accion === catCambios.CAMBIO_PASAJERO) &&
                                <CambioPasajeros />
                            }
                            {
                                (accion === catCambios.CANCELACIONES) &&
                                <Cancelaciones />
                            }
                            {
                                (accion === catCambios.CAMBIO_PAQUETE) &&
                                <CambioPaquete />
                            }
                        </Grid>
                    }
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VCambios